import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {titleCase} from "../../../../utils/utils"
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function ArrestWarrantTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };         

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Número do Mandato</TableCell>
            <TableCell className={classes.tableHeader}>Processo de Origem</TableCell>
            <TableCell className={classes.tableHeader}>Nome</TableCell>
            <TableCell className={classes.tableHeader}>Agência Solicitadora</TableCell>
            <TableCell className={classes.tableHeader}>Status</TableCell>
            <TableCell className={classes.tableHeader}>Duração da Sentença</TableCell>
            <TableCell className={classes.tableHeader}>Início do Mandato</TableCell>
            <TableCell className={classes.tableHeader}>Mandato de Recaptura</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.arrest_warrant_data.map((warrant,index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            > 
              <TableCell style={{wordBreak:"break-all"}} className={classes.tableText}>
                {warrant.arrest_warrant_number ? warrant.arrest_warrant_number : "-"}
              </TableCell>
              <TableCell style={{wordBreak:"break-all"}} className={classes.tableText}>
                {warrant.process_number}
              </TableCell>
              <TableCell style={{whiteSpace:"nowrap"}} className={classes.tableText}>
                {titleCase(warrant.name, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(warrant.agency, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(warrant.status, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(warrant.sentence_length, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {warrant.start_date == null ? "-" : moment(warrant.start_date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell style={{whiteSpace:"nowrap"}} className={classes.tableText}>
                {warrant.is_recapture_warrant ? "Sim" :
                warrant.is_recapture_warrant ===false ? "Não": "Indisponível"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default ArrestWarrantTable;